var debounce = require('../util/debounce');
var cartInventoryValidator = require('../cart/cartInventoryValidator');
var deliveryUtils = require('../components/deliveryModal/deliveryUtils');

const debouncedTriggerChange = debounce(function($select) {
    $select.change();
}, 250);

function createOverlayInput($select, currentValue) {
    // Create input element
    const $overlay = $('<input>')
        .addClass('quantity-overlay-input')
        .attr('type', 'text')
        .val(currentValue)
        .css({
            position: 'absolute',
            width: $select.outerWidth(),
            height: $select.outerHeight(),
            top: $select.position().top,
            left: $select.position().left,
            zIndex: 1000,
            textAlign: 'center'
        });

    // Insert input right after select
    $select.after($overlay);

    // Select all text for easier overrite
    $overlay.select();

    return $overlay;
}

function showStepValidationError(minQty, stepQty) {
    $('.step-validation-error').remove();

    const step = minQty * stepQty;

    $(document).trigger('showNotificationClient', {
        type: 'error',
        message: `Este producto solo se puede comprar en cantidades múltiplos de ${step}`,
        cssClass: ''
    });
}


function handleOverlayInputChange($input, $select) {
    let value = parseInt($input.val(), 10);
    const maxQty = parseInt($select.data('max-quantity'), 10);
    const minQty = parseInt($select.data('min-order-quantity'), 10);
    const stepQty = parseInt($select.data('step-quantity'), 10) || 1;
    const wasOverMax = value > maxQty;

    // Validate and adjust value
    if (isNaN(value) || value < minQty) {
        value = minQty;
    } else if (value > maxQty) {
        value = maxQty;
    }

    // Check if the value is valid according to the step formula
    const isValidStep = (value % (minQty * stepQty)) === 0 && (value / (minQty * stepQty)) >= 1;
    if (!isValidStep) {
        showStepValidationError(minQty, stepQty);
        value = parseInt($select.val(), 10); // Keep current value
        $input.remove();
        return;
    }

    // Update select and trigger change
    $select.val(value).trigger('change');

    // Update quantity state
    const $quantitySelectorContainer = $select.closest('.quantity-selector');
    const quantitySelector = getQuantitySelectorControls($quantitySelectorContainer);
    updateQuantityState(quantitySelector, value, $quantitySelectorContainer);

    // When the product maximum is exceeded through the input, show the long
    // adjustment message using the existing tooltip mechanism
    if (wasOverMax) {
        const adjustedMessage = $quantitySelectorContainer.data('max-quantity-message-adjusted');
        if (adjustedMessage) {
            quantitySelector.$tooltipStockMsgPDP.find('.notification-message').text(adjustedMessage);
            quantitySelector.$tooltipStockMsgPDP.removeClass('d-none');
        }
    }

    // Remove overlay input
    $input.remove();
}

function initQuantityOverlayInput() {
    $(document).on('mousedown', '.quantity-form.quantity-selector select', function(e) {
        e.preventDefault();
    });

    $(document).on('click', '.quantity-form.quantity-selector', function(e) {
        // Ignore clicks on the increase/decrease buttons
        if ($(e.target).closest('.quantity-decrease, .quantity-increase').length) {
            return;
        }

        const $select = $(this).find('select');
        const currentValue = $select.val();

        if (parseInt(currentValue) === 1 && parseInt($select.data('max-quantity'), 10) === 1) {
            return;
        }

        // Create overlay input
        const $input = createOverlayInput($select, currentValue);

        // Handle enter key
        $input.on('keypress', function(e) {
            if (e.which === 13) {
                handleOverlayInputChange($input, $select);
            }
        });

        // Handle blur
        $input.on('blur', function() {
            handleOverlayInputChange($input, $select);
        });
    });
}

function getQuantitySelectorControls ($container) {
    const decreaseBtn = $container.find('.quantity-decrease');
    const increaseBtn = $container.find('.quantity-increase');
    const selectElement = $container.find('select.quantity-select');
    const tooltipStockMsgPDP = $('.msg-product-actions-pdp.tooltip-stock');
    const stockMessageText = tooltipStockMsgPDP.find('.notification-message').text();
    const btnAddToCart = $container.parent().find('button.add-to-cart');

    let currentQuantity = parseInt(selectElement.val(), 10);
    let minQuantity = parseInt(selectElement.data('min-order-quantity'), 10);
    let maxQuantity = parseInt(selectElement.data('max-quantity'), 10);
    let stepQuantity = parseInt(selectElement.data('step-quantity'), 10) || 1;
    let effectiveLimit = parseInt(selectElement.data('effective-limit'), 10);
    let effectiveMaxQuantity = Number.isNaN(effectiveLimit) ? maxQuantity : Math.min(maxQuantity, effectiveLimit);

    return {
        $decreaseBtn: decreaseBtn,
        $increaseBtn: increaseBtn,
        $selectElement: selectElement,
        $tooltipStockMsgPDP: tooltipStockMsgPDP,
        $stockMessageText: stockMessageText,
        $currentQuantity: currentQuantity,
        $minQuantity: minQuantity,
        $maxQuantity: maxQuantity,
        $effectiveLimit: effectiveMaxQuantity,
        $stepQuantity: stepQuantity,
        $btnAddToCart: btnAddToCart
    }
}

function updateQuantityState(quantitySelector, currentQuantity, $quantitySelectorContainer) {
    // Force numeric conversion to avoid type comparison issues
    currentQuantity = parseInt(currentQuantity, 10);
    const minQuantity = parseInt(quantitySelector.$minQuantity, 10);
    const selectMax = parseInt(quantitySelector.$maxQuantity, 10);
    const effectiveMax = parseInt(quantitySelector.$effectiveLimit, 10);

    const isAtMinimum = currentQuantity <= minQuantity || currentQuantity <= 1;
    const isAtMaximum = currentQuantity === effectiveMax;
    const isOverMaximum = currentQuantity > selectMax;

    // Enable/disable decrease button
    quantitySelector.$decreaseBtn.prop('disabled', isAtMinimum);

    // Enable/disable increase button and show/hide tooltip
    quantitySelector.$increaseBtn.prop('disabled', currentQuantity >= effectiveMax || isOverMaximum);
    quantitySelector.$tooltipStockMsgPDP.toggleClass('d-none', !isAtMaximum);

    // Set the tooltip message according to the limit that caused the maximum
    const maxQuantityMessage = $quantitySelectorContainer.data('max-quantity-message');
    if (maxQuantityMessage) {
        quantitySelector.$tooltipStockMsgPDP.find('.notification-message')
            .text(isAtMaximum ? maxQuantityMessage : quantitySelector.$stockMessageText);
    }

    // Update max quantity class - only when exactly at maximum
    $quantitySelectorContainer.toggleClass('is-max-quantity', isAtMaximum && currentQuantity !== 1);

    // Remove error state if quantity is valid
    if (currentQuantity <= selectMax) {
        $quantitySelectorContainer.closest('.product-info').removeClass('error-state');
    }

    if (isOverMaximum) {
        cartInventoryValidator.disableProductCard($quantitySelectorContainer);
    }

    if (!$('.error-state').length) {
        cartInventoryValidator.enableCheckoutBegin();
    }
}

/**
 * Updates the quantity and shows the value on display
 * @param {Object} element - action button for increase or decrease.
 * @param {boolean} isIncrease - True indicates the increase action will be fire, and false for descrease action.
 */
function handleUpdateQuantity(element, isIncrease) {
    const $quantitySelectorContainer = $(element).closest('.quantity-selector');
    const $minicart = $(element).closest('.minicart');
    const quantitySelector = getQuantitySelectorControls($quantitySelectorContainer);
    let currentQuantity = quantitySelector.$currentQuantity;
    const minQty = quantitySelector.$minQuantity;
    const stepQty = quantitySelector.$stepQuantity;


    if ($minicart.length) {
        $minicart.find('.popover').spinner().start();
    }

    // Update quantity
    if (isIncrease && currentQuantity < quantitySelector.$effectiveLimit) {
        const currentI = Math.ceil(currentQuantity / (minQty * stepQty));
        const nextValue = minQty * (currentI + 1) * stepQty;

        // Use next step if it's within the effective limit, otherwise use the limit
        currentQuantity = nextValue <= quantitySelector.$effectiveLimit
            ? nextValue
            : quantitySelector.$effectiveLimit;

    } else if (!isIncrease && currentQuantity > quantitySelector.$minQuantity) {
        const prevValue = currentQuantity - (minQty * stepQty);
        currentQuantity = prevValue >= (minQty * stepQty) ? prevValue : (minQty * stepQty);
    }

    updateQuantityState(quantitySelector, currentQuantity, $quantitySelectorContainer);
    quantitySelector.$selectElement.val(currentQuantity);
    debouncedTriggerChange(quantitySelector.$selectElement);
}

/**
 * Initialize quantity buttons states based on quantities (enable/disable button).
 * When a scope is provided only the selectors inside it are initialized (used after
 * the mini cart popover content is refreshed).
 * @param {jQuery} [$scope] - Optional container to scope the initialization to
 */
function setupInitialQuantityState($scope) {
    var $selectors = ($scope && $scope.length)
        ? $scope.find('.quantity-selector')
        : $('.quantity-selector');

    $selectors.each(function() {
        const $quantitySelectorContainer = $(this);
        const quantitySelector = getQuantitySelectorControls($quantitySelectorContainer);
        const minQuantity = quantitySelector.$minQuantity;
        const maxQuantity = quantitySelector.$maxQuantity;
        const currentQuantity = quantitySelector.$currentQuantity;
        const noStock = minQuantity === 0 && maxQuantity === 0;
        const hasShippingMethod = deliveryUtils.hasShippingMethod();

        if (noStock) {
            if (hasShippingMethod) {
                quantitySelector.$btnAddToCart.attr('disabled', noStock);
                if (quantitySelector.$selectElement.find('option[value="0"]').length === 0) {
                    quantitySelector.$selectElement.append('<option value="0" selected>0</option>');
                }
            }
            else {
                quantitySelector.$selectElement.attr('disabled', true);
            }
        }

        quantitySelector.$decreaseBtn.prop('disabled', noStock || currentQuantity === minQuantity || maxQuantity <= 0);
        quantitySelector.$increaseBtn.prop('disabled', noStock || currentQuantity >= quantitySelector.$effectiveLimit || maxQuantity <= 0);

        // The tooltip close handlers are only bound on the page load initialization
        if (!($scope && $scope.length)) {
            quantitySelector.$tooltipStockMsgPDP.find('.close.btn-close').on('click', function() {
                quantitySelector.$tooltipStockMsgPDP.addClass('d-none');
            });
        }

        $quantitySelectorContainer.toggleClass(
            'is-max-quantity',
            currentQuantity === quantitySelector.$effectiveLimit && currentQuantity != 1
        );
    });

    if (!($scope && $scope.length)) {
        $(document).on('click', '.msg-product-actions-pdp.tooltip-stock .close.btn-close', function() {
                $(this).closest('.msg-product-actions-pdp.tooltip-stock').addClass('d-none');
        });
    }
}

/**
 * Initialize quantity buttons feature.
 */
function initQuantityButtons() {
    setupInitialQuantityState();

    $(document).on('click', '.quantity-increase', function () {
        handleUpdateQuantity(this, true); // send true for increase
    });

    $(document).on('click', '.quantity-decrease', function () {
        handleUpdateQuantity(this, false); // send false for decrease
    });

    initQuantityOverlayInput();
}

module.exports = {
    initQuantitySelector: initQuantityButtons,
    getQuantitySelectorControls: getQuantitySelectorControls,
    updateQuantityState: updateQuantityState,
    setupInitialQuantityState: setupInitialQuantityState
}
